(function () {
    'use strict';

    angular
        .module('app')
        .controller('ConfirmBookingController', ConfirmBookingController);

    ConfirmBookingController.$inject = ['$http', '$state', '$stateParams', '$scope', '$q', '$location', '$rootScope', '$cookies', 'dialog'];

    function ConfirmBookingController($http, $state, $stateParams, $scope, $q, $location, $rootScope, $cookies, dialog) {
        var vm = this;
        vm.$onInit = init;
        vm.close = close;
        vm.confirmBooking = confirmBooking;
        vm.lowFiBookingFeeInfo = lowFiBookingFeeInfo;
        vm.bookingTermsInfo = bookingTermsInfo;

        function init() {
            window.document.title = $stateParams.language == 'da' ? "Booking - Be My Concert" : "Booking - Be My Concert";
            vm.band_booking_token = $stateParams.band_booking_token;
            getBookingDetails();
            vm.showContract =  $stateParams.show_contract
        }

        function getBookingDetails() {
            return $http.get('api/booking/band/' + vm.band_booking_token)
                .then(function (response) {
                    vm.details = response.data;

                    if(vm.details.band_booking_status == "confirmed") {
                        if(!vm.showContract) {
                            vm.confirmed = true;
                        } else {

                        }

                    }
                    vm.details.band_booking_date = moment(vm.details.band_booking_date).toDate();
                    vm.details.band_booking_time = moment(vm.details.band_booking_time, "hh:mm:ss").toDate();

                    vm.details.band_booking_low_fi_share = Math.round(vm.details.band_booking_fee * vm.details.band_booking_lowfi_percentage)/100;
                    vm.details.band_booking_musician_share = Math.round(vm.details.band_booking_fee * vm.details.band_booking_band_percentage)/100;
                });
        }

        function confirmBooking() {
            $http.post('api/booking/band/' + vm.band_booking_token + '/confirm')
                .then(function (response) {
                    vm.confirmed = true;
                }).catch(function() {
                    vm.error = true;
                });
        }

        function close() {
            return history.back();
        }


        function bookingTermsInfo() {
            dialog.info('booking-terms-info');
        }

        function lowFiBookingFeeInfo() {
            dialog.info('low-fi-booking-fee-info');
        }

    }
})();
